function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 8,
  fill: "#DCDCE4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.263 29.674v3.172h-7.195v5.094h-4.841v-5.094H14v-3.172h2.227V26.85H14v-3.172h2.227V11h6.84c1.746 0 3.29.143 4.63.43 1.342.287 2.464.742 3.383 1.35.91.615 1.611 1.391 2.083 2.336.473.945.709 2.092.709 3.425 0 1.265-.22 2.412-.658 3.432a6.712 6.712 0 01-2 2.615c-.893.726-2.015 1.274-3.356 1.67-1.35.388-2.927.59-4.74.59h-2.05v2.826h7.195zm-7.195-15.503v9.506h2.7c.876 0 1.652-.126 2.327-.371a4.96 4.96 0 001.704-1.02c.464-.43.81-.937 1.054-1.519a4.906 4.906 0 00.363-1.872c0-.65-.11-1.257-.337-1.83a4.087 4.087 0 00-1.03-1.502c-.455-.422-1.037-.759-1.737-1.012-.7-.245-1.535-.371-2.497-.371h-2.547v-.009z",
  fill: "#000"
});

function SvgRub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "979178276ecf0741d7f14e324314cac9.svg";
export { SvgRub as ReactComponent };